import { printOrderLabel } from "@/lib/printLabel";
import { PAYMENT_METHOD_LABELS } from "@/lib/fulfillment";
import { orderNumber } from "@/lib/orderNumber";

// order.customer_name/phone are free text from the store-billing form,
// written into this receipt's HTML via document.write() — which runs in
// the cashier's own browser session (same origin, full access to
// localStorage, including the Supabase auth token). Without escaping, a
// crafted customer name/phone could inject a script that runs the moment
// the receipt is printed.
function escapeHtml(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function printStoreReceipt(order) {
  const ordNum = orderNumber(order);
  const date = new Date().toLocaleString("en-IN", {
    day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
  });
  const pay = PAYMENT_METHOD_LABELS[order.payment_method] || order.payment_method || "—";

  const itemRows = (order.items || []).map((it, i) =>
    `<tr>
      <td style="padding:4px 6px;border-bottom:1px solid #e8d5b0;">${i + 1}.</td>
      <td style="padding:4px 6px;border-bottom:1px solid #e8d5b0;font-weight:600;">${escapeHtml(it.name)}</td>
      <td style="padding:4px 6px;border-bottom:1px solid #e8d5b0;">${escapeHtml(it.size)}</td>
      <td style="padding:4px 6px;border-bottom:1px solid #e8d5b0;text-align:center;">×${escapeHtml(it.quantity)}</td>
      <td style="padding:4px 6px;border-bottom:1px solid #e8d5b0;text-align:right;">₹${(it.price * it.quantity).toLocaleString("en-IN")}</td>
    </tr>`
  ).join("");

  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"/><title>Bill ${ordNum}</title>
  <style>@page{size:80mm auto;margin:4mm}body{font-family:Arial,sans-serif;font-size:12px;color:#1a0a04;padding:8px}
  h1{font-size:16px;margin:0 0 4px;color:#5A2D1D}table{width:100%;border-collapse:collapse;margin:8px 0}
  .total{font-size:15px;font-weight:bold;text-align:right;margin-top:8px;color:#5A2D1D}</style></head><body>
  <h1>Annapurna Home Pickles</h1>
  <div style="font-size:11px;color:#666">Home Order · ${date}</div>
  <div style="margin:6px 0"><b>Bill:</b> ${ordNum}</div>
  <div><b>Customer:</b> ${escapeHtml(order.customer_name) || "Walk-in"}</div>
  ${order.phone ? `<div><b>Phone:</b> ${escapeHtml(order.phone)}</div>` : ""}
  <div><b>Paid:</b> ${pay} (no card)</div>
  <table><thead><tr style="background:#EFD9B4"><th></th><th>Item</th><th>Size</th><th>Qty</th><th>Amt</th></tr></thead><tbody>${itemRows}</tbody></table>
  <div style="text-align:right;font-size:11px">Subtotal: ₹${(order.subtotal || 0).toLocaleString("en-IN")}</div>
  <div style="text-align:right;font-size:11px">GST (${order.gst_percent ?? 5}%): ₹${(order.gst_amount || 0).toLocaleString("en-IN")}</div>
  <div class="total">Total: ₹${(order.total || 0).toLocaleString("en-IN")}</div>
  <div style="margin-top:12px;font-size:10px;text-align:center;color:#666">Thank you! తరచుగా రండి 🙏</div>
  <script>window.onload=function(){window.print();}</script></body></html>`;

  const w = window.open("", "_blank", "width=320,height=600");
  if (!w) return;
  w.document.write(html);
  w.document.close();
}

export { printOrderLabel };
